import { render } from "./BaseIconSoftdrinks.vue?vue&type=template&id=64a6183a"
import script from "./BaseIconSoftdrinks.vue?vue&type=script&lang=js"
export * from "./BaseIconSoftdrinks.vue?vue&type=script&lang=js"

import exportComponent from "/home/projects/cc-gastro/htdocs/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/BaseIconSoftdrinks.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "64a6183a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('64a6183a', __exports__)) {
    console.log('reload')
    api.reload('64a6183a', __exports__)
  }
  
  module.hot.accept("./BaseIconSoftdrinks.vue?vue&type=template&id=64a6183a", () => {
    console.log('re-render')
    api.rerender('64a6183a', render)
  })

}


export default __exports__